import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";

import routes from "./routes";

const RouteWrapper = ({ children }) => {
  useEffect(() => {
    document.getElementsByClassName("ant-layout-content")[0].scrollTop = 0;
  }, []);

  return children;
};

const LeadsContent = ({ ...props }) => {
  return (
    <div className="relative flex-1 overflow-auto bg-gray-100 company-submission-height">
      <Switch>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            children={
              <RouteWrapper>
                <route.component {...props} />
              </RouteWrapper>
            }
          />
        ))}
      </Switch>
    </div>
  );
};

export default LeadsContent;
